var Chainable = require('../../Chainable')
var isMap = require('./map')

/**
 * @func isMapish
 *
 * @memberOf is
 * @since 3.0.0
 * @extends isMap
 * @variation also checks `instanceof Chainable`
 *
 * @param  {*} x value to check
 * @return {boolean} isMapish
 *
 * @example
 *
 *    isMapish(new Map)
 *    //=> true
 *
 *    isMapish(new Chain)
 *    //=> true
 *
 *    isMapish({})
 *    //=> false
 *
 *    isMapish(1)
 *    //=> false
 *
 */
module.exports = function (x) { return isMap(x) || x instanceof Chainable; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwaXNoLmpzIiwic291cmNlcyI6WyJtYXBpc2guanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgQ2hhaW5hYmxlID0gcmVxdWlyZSgnLi4vLi4vQ2hhaW5hYmxlJylcbmNvbnN0IGlzTWFwID0gcmVxdWlyZSgnLi9tYXAnKVxuXG4vKipcbiAqIEBmdW5jIGlzTWFwaXNoXG4gKlxuICogQG1lbWJlck9mIGlzXG4gKiBAc2luY2UgMy4wLjBcbiAqIEBleHRlbmRzIGlzTWFwXG4gKiBAdmFyaWF0aW9uIGFsc28gY2hlY2tzIGBpbnN0YW5jZW9mIENoYWluYWJsZWBcbiAqXG4gKiBAcGFyYW0gIHsqfSB4IHZhbHVlIHRvIGNoZWNrXG4gKiBAcmV0dXJuIHtib29sZWFufSBpc01hcGlzaFxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogICAgaXNNYXBpc2gobmV3IE1hcClcbiAqICAgIC8vPT4gdHJ1ZVxuICpcbiAqICAgIGlzTWFwaXNoKG5ldyBDaGFpbilcbiAqICAgIC8vPT4gdHJ1ZVxuICpcbiAqICAgIGlzTWFwaXNoKHt9KVxuICogICAgLy89PiBmYWxzZVxuICpcbiAqICAgIGlzTWFwaXNoKDEpXG4gKiAgICAvLz0+IGZhbHNlXG4gKlxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4gaXNNYXAoeCkgfHwgeCBpbnN0YW5jZW9mIENoYWluYWJsZVxuIl0sIm5hbWVzIjpbImNvbnN0Il0sIm1hcHBpbmdzIjoiQUFBQUEsR0FBSyxDQUFDLFNBQVMsR0FBRyxPQUFPLENBQUMsaUJBQWlCLENBQUM7QUFDNUNBLEdBQUssQ0FBQyxLQUFLLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQTRCOUIsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFBLENBQUMsQ0FBQSxDQUFDLEFBQUcsU0FBQSxLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxZQUFZLFNBQVMsR0FBQTsifQ==